// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"kiosk-locale-select_clearfix_3WM68"};